module.exports = __webpack_public_path__ + "img/avatar.7be21f62.svg";